import React from 'react';
import styles from './InfoCard.module.css';

interface InfoField {
  label: string;
  value: string;
  isLink?: boolean;
  linkIcon?: boolean;
}

interface InfoCardProps {
  title: string;
  icon: 'personal' | 'contact';
  fields: InfoField[];
}

const cardIcons: Record<string, React.ReactNode> = {
  personal: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  ),
  contact: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  ),
};

export const InfoCard: React.FC<InfoCardProps> = ({ title, icon, fields }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.headerIcon}>{cardIcons[icon]}</span>
        <h3 className={styles.title}>{title}</h3>
      </div>
      <div className={styles.fields}>
        {fields.map((field, index) => (
          <div key={index} className={styles.field}>
            <span className={styles.label}>{field.label}</span>
            {field.isLink ? (
              <a href="#" className={styles.link}>
                {field.value}
                {field.linkIcon && (
                  <svg viewBox="0 0 24 24" fill="currentColor" className={styles.linkIcon}>
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                  </svg>
                )}
              </a>
            ) : (
              <span className={styles.value}>{field.value}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
